<template>
  
  <div>

    <b-breadcrumb :items="$options.breadcrumb"/>


    <div class="d-flex align-items-center justify-content-between">
      <template v-if="editMode">
        <h2>Profiel bewerken</h2>
        <div>
          <b-btn variant="secondary" @click="openTest">Test</b-btn>
          <busy-btn variant="primary" @click="save" class="ml-2" :busy="saveBusy"><span class="mdi mdi-content-save-outline"/> Opslaan</busy-btn>
        </div>
      </template>
      <template v-else>
        <h2>Nieuw profiel maken</h2>
        <div>
          <b-btn variant="secondary" @click="openTest">Test</b-btn>
          <b-btn variant="primary" @click="create" class="ml-2">Maken</b-btn>
        </div>
      </template>
    </div>

    <b-form>
      <b-form-group label="Profiel naam" label-class="font-weight-bold">
        <b-input v-model="workingCopy.name"/>
      </b-form-group>
      <b-form-group label="Tellers" label-class="font-weight-bold">

        <div class="text-center">
          <b-alert show variant="warning" class="d-inline-block">
            <span class="mdi mdi-alert-outline"/>
            Meerdere lijnen met dezelfde tellergroep zullen worden tezamen geteld in het eindresultaat
            <span class="mdi mdi-alert-outline"/></b-alert>
        </div>

        <b-table-lite :items="workingCopy.counters" :fields="$options.fields" small class="counters-table">
          <template v-slot:cell(name)="row">
            <b-select :options="cgroups.nodes" v-model="row.item.cgroup.connectById.id" text-field="displayName" value-field="id">
              <template v-slot:first>
                <b-form-select-option value="" disabled>-- Selecteer --</b-form-select-option>
              </template>
            </b-select>
          </template>
          <template v-slot:cell(expr)="row">
            <b-textarea v-model="row.item.expr"/>
<!--            <b-input v-model="row.item.expr"/>-->
          </template>
          <template v-slot:cell(description)="row">
            <b-input v-model="row.item.description"/>
          </template>
          <template v-slot:cell(actions)="row">
            <b-btn variant="danger" @click="removeCounter(row)"><i class="mdi mdi-minus"/></b-btn>
          </template>
          <template v-slot:custom-foot>
            <b-tr>
              <b-td colspan="3" class="text-center">
                <b-btn size="sm" variant="success" @click="addRow"><span class="mdi mdi-plus-thick"/></b-btn>
              </b-td>
            </b-tr>
          </template>
        </b-table-lite>

      </b-form-group>
    </b-form>


    <p>
      Beschikbare functies: oid()
    </p>

    <b-modal v-model="showTest" centered size="xl" ok-only ok-title="Sluiten" >
      <b-row style="height: 35em">
        <b-col>
          <h4 class="text-center">Kies printer</h4>
        <search-printer @add="runTest" />
        </b-col>
        <b-col>
          <h4 class="text-center">Resultaat</h4>

          <template v-if="testBusy">
            <p class="text-center"><b-spinner label="Spinning" /></p>
          </template>
          <template v-else>
            <b v-if="timedOut">Timeout</b>
            <b-table-simple v-else small>
              <b-thead>
                <b-tr>
                  <b-th>Tellergroep</b-th>
                  <b-th>Waarde</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(e, idx) in testResult" :key="`t_${idx}`">
                  <b-td>{{e.idx}}</b-td>
                  <b-td>
                    <template v-if="e.value === null"><i>Null</i></template>
                    <template v-else>{{e.value}}</template>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </template>
        </b-col>
      </b-row>

    </b-modal>

  </div>
  
</template>

<script>
import clone from 'stringify-clone';
import get from 'lodash/get';
import actionField from '../../lib/actionField';
import {CACHE_AND_NETWORK, NETWORK_ONLY} from '@/lib/constants';
import SearchPrinter from '@/components/SearchPrinter';
import BusyBtn from '@/components/BusyBtn';

function newWorkingCopy(existing = {})
{
    const c = clone(existing);

    return {
        name: existing.name,
        counters: get(c, 'counters.nodes', [])
            .map(c => ({...c, cgroup: { connectById: c.cgroup} }) )
    }
}

export default
{
    components: {BusyBtn, SearchPrinter},
    apollo:
    {
        cgroups:
        {
            query: require('../../graphql/counter_group_dropdown.gql'),
            fetchPolicy: CACHE_AND_NETWORK
        }
    },
    async created()
    {
        if(!this.editMode)
            return;

        const { data } = await this.$apollo.query(
            {
                query: require('../../graphql/forEditProfile.query.gql'),
                variables: { id: this.id },
                fetchPolicy: NETWORK_ONLY
            }
        );

        this.$set(this, 'workingCopy', newWorkingCopy(data.profileById));
    },
    data()
    {
        return {
            editMode: Boolean(this.id),
            workingCopy: newWorkingCopy(),
            cgroups: { nodes: [] },
            showTest: false,
            testResult: [],
            timedOut: false,
            testBusy: false,
            saveBusy: false
        }
    },
    methods:
    {
        addRow()
        {
            this.workingCopy.counters.push({cgroup: {connectById: { id: '' } }, expr: ''});
        },
        async create()
        {
            const variables =
                {
                    input:
                    {
                        profile:
                        {
                            name: this.workingCopy.name,
                            counters:
                            {
                                create: this.workingCopy.counters
                            }
                        }
                    }
                };

            const result = await this.$apollo.mutate(
                {
                    mutation: require('../../graphql/createProfile.mutation.gql'),
                    variables
                }
            );

            console.log(result);
        },
        async save()
        {
            this.saveBusy = true;

            try
            {
                const variables =
                {
                    input:
                    {
                        id: this.id,
                        patch:
                        {
                            name: this.workingCopy.name,
                            counters:
                            {
                                create: this.workingCopy.counters.filter(c => !c.id),
                                deleteOthers: true,
                                updateById: this.workingCopy.counters
                                    .filter(c => c.id)
                                    .map(c =>
                                    {
                                        return {
                                            id: c.id,
                                            patch:
                                            {
                                                cgroup: { connectById: { id: c.cgroup.connectById.id } },
                                                name: c.name,
                                                expr: c.expr,
                                                description: c.description,
                                            }
                                        }
                                    })
                            }
                        }
                    }
                };

                const { data } = await this.$apollo.mutate(
                    {
                        mutation: require('../../graphql/saveProfile.mutation.gql'),
                        variables
                    }
                );

                this.$set(this, 'workingCopy', newWorkingCopy(data.updateProfileById.profile));
            }
            finally
            {
                this.saveBusy = false;
            }
        },
        removeCounter(row)
        {
            this.workingCopy.counters.splice(row.index, 1);
        },
        runTest(row)
        {
            this.testBusy = true;
            this.timedOut = false;
            this.testResult = [];

            const obs = this.$apollo.subscribe(
                {
                    query: require('../../graphql/live/profile_test.gql'),
                    variables:
                    {
                        id: row.id,
                        lines: this.workingCopy.counters.map(c =>
                            (
                                {
                                    idx: this.cgroups.nodes.find(({id}) => id === c.cgroup.connectById.id).displayName,
                                    expr: c.expr
                                }
                            )
                        )
                    }
                }
            );

            let timeout, sub;
            const self = this;

            function cleanup()
            {
                if(timeout) clearTimeout(timeout);
                if(sub) sub.unsubscribe();

                self.testBusy = false;
            }

            sub = obs.subscribe(
                {
                    next({data})
                    {
                        self.testResult = data.profileTest.values;
                        cleanup();
                    },
                    error(errorValue)
                    {
                        console.error(errorValue);
                        cleanup();
                    }
                }
            );

            timeout = setTimeout(() => { this.timedOut = true; cleanup() }, 15000);
        },
        openTest()
        {
            this.testBusy = false;
            this.testResult = [];
            this.timedOut = false;
            this.showTest = true
        }
    },
    async mounted()
    {
        if(this.from)
        {
            const { data: { profileById } } = await this.$apollo.query(
                {
                    query: require('../../graphql/forEditProfile.query.gql'),
                    variables: { id: this.from },
                    fetchPolicy: NETWORK_ONLY
                }
            );

            const asNew =
            {
                name: profileById.name + ' (copy)',
                counters:
                {
                    nodes: profileById.counters.nodes.map(c => ({name: c.name, expr: c.expr, cgroup: { id: c.cgroup.id }}))
                },
                description: profileById.description
            };

            this.$set(this, 'workingCopy', newWorkingCopy(asNew));
        }
    },
    props: ['id', 'from'],
    fields:
    [
        {
            key: 'name',
            label: 'Tellergroep'
        },
        {
            key: 'expr',
            label: 'SNMP'
        },
        {
            key: 'description',
            label: 'Beschrijving'
        },
        actionField
    ],
    breadcrumb:
    [
        {text: 'Configuratie'},
        {text: 'Printer profielen', to: '/main/config/profiles'},
        {text: 'Nieuw profiel maken'}
    ],
}
</script>

<style>
table.counters-table { table-layout: fixed; }

  .counters-table tr th:nth-child(1)
  {
      width: 15em;
  }
  .counters-table tr th:nth-child(2)
  {
    width: 50%;
  }
  .counters-table tr th:nth-child(3)
  {
      width: 50%
  }
  .counters-table tr th:nth-child(4)
  {
      width: 50px;
  }
</style>